export const GET_XEALTH_PROGRAM_SUCCESS = 'src/containers/Xealth/V1/program/GET_XEALTH_PROGRAM_SUCCESS';
export const GET_XEALTH_PROGRAM_FAILED = 'src/containers/Xealth/V1/program/GET_XEALTH_PROGRAM_FAILED';
